angular.module('contentful')
.directive('cfTestEntryEditor', ['require', require => {
  var createEditorController = require('app/entity_editor/EntryController').default;

  return {
    restrict: 'E',
    scope: true,
    template: JST.entry_editor(),
    controller: ['$scope', createEditorController]
  };
}]);



// WEBPACK FOOTER //
// ./src/javascripts/app/entity_editor/cf_test_entry_editor_directive.js